// extracted by mini-css-extract-plugin
export default {"content":"AppointmentWhat_content__E2L69"};